import React from 'react';
import { CheckCircle, Phone, Home } from 'lucide-react';
import { Link } from 'react-router-dom';
import './ThankYou.css';

export default function ThankYou() {
  return (
    <div className="ty-page">
      <div className="ty-card">
        <div className="ty-icon">
          <CheckCircle size={48} color="var(--green)" strokeWidth={1.5} />
        </div>

        <h1>Thank You!</h1>
        <p className="ty-sub">
          Your quote request has been received. A home warranty advisor will
          contact you within <strong>2 hours</strong> with your personalized quote.
        </p>

        <div className="ty-summary-label">What happens next?</div>
        <div className="ty-steps">
          <div className="ty-step">
            <div className="ty-num">1</div>
            <div className="ty-step-text">
              <strong>Advisor calls you</strong>
              <span>We'll match you with the right plan for your home and budget.</span>
            </div>
          </div>
          <div className="ty-step">
            <div className="ty-num">2</div>
            <div className="ty-step-text">
              <strong>Review your options</strong>
              <span>No pressure — compare plans at your own pace.</span>
            </div>
          </div>
          <div className="ty-step">
            <div className="ty-num">3</div>
            <div className="ty-step-text">
              <strong>Coverage starts fast</strong>
              <span>Most homeowners activate coverage within 24 hours.</span>
            </div>
          </div>
        </div>

        <a href="tel:18005550100" className="ty-call-btn">
          <Phone size={18} strokeWidth={2} />
          Call us now: (800) 555-0100
        </a>

        <Link to="/" className="ty-home-link">
          <Home size={15} strokeWidth={2} />
          Back to Home
        </Link>
      </div>
    </div>
  );
}
